// extracted by mini-css-extract-plugin
export default {"school":"Schoolinfo_school__-0585"};